<template>
  <div>
    <el-form :model="form" :rules="rules" ref="columnForm">
      <el-form-item label="模式选择：" :label-width="formLabelWidth" prop="mode">
        <el-radio-group v-model="form.mode" @input="inputMode()">
          <el-radio :label="1">仅按学段控制</el-radio
          ><span style="color: #aaaaaa">（*开放指定学段的所有学科权限）</span>
          <p></p>
          <el-radio :label="2">仅按学段-学科控制</el-radio
          ><span style="color: #aaaaaa">（*开放指定学段-学科权限）</span>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.mode == 1" label="学段选择：" :label-width="formLabelWidth" prop="xueduan">
        <el-checkbox-group v-model="form.xueduan" @change="changeXueduan()">
          <el-checkbox label="1" value="1">小学</el-checkbox>
          <el-checkbox label="2" value="2">初中</el-checkbox>
          <el-checkbox label="3" value="3">高中</el-checkbox>
          <el-checkbox label="4" value="4">中职</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-if="form.mode == 2">
        <el-table :data="form.subject_list" style="width:100%" border>
            <el-table-column label="学段" prop="stage_name" width="80"></el-table-column>
            <el-table-column label="学科" prop="list">
                <template slot-scope="scope">
                    <el-checkbox-group v-model="scope.row.ids" @change="changeXueke(scope.row.ids)">
                        <el-checkbox v-for="subject in scope.row.list" :key="subject.subject_id" :label="subject.subject_id">{{subject.subject_name}}</el-checkbox>
                    </el-checkbox-group>
                </template>
            </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    config: {
      required: true,
      type: Object,
    },
    product_id: {
      required: true,
    },
    customer_id: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      formLabelWidth: "100px",
      rules: {
          mode: [
            { required: true, message: '请选择模式', trigger: 'change' }
          ],
          xueduan: [
            { required: true, message: '请至少选择1个学段', trigger: 'change' }
          ],
        },
      form: {
        subject_list: [],
        xueduan: [],
        mode: '',
      },
    };
  },
  created() {
    this.form.mode = parseInt(this.config.pattern);
    this.form.xueduan = this.config.stage.split(",");
    this.form.subject_list = this.config.subject_list;
  },
  mounted() {
    this.emit(); // 移动到mounted钩子中
  },
  methods: {
    emit(){
      //这勾八校验用不来，换接口来校验
          this.$emit('changeColumn', this.form);
    },

    /**
     * 修改学段
     * */
    changeXueduan() {
      this.emit();
    },

    /**
     * 修改学科
     * */
     changeXueke(ids) {
      this.emit();
    },

    /**
     * 修改模式
     * */
    inputMode() {
      this.emit();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/order/vr/columnLimit.vue